import { SignedIn, SignedOut, UserButton } from "@clerk/tanstack-react-start";
import { Link, useRouteContext } from "@tanstack/react-router";
import { Moon, Sun } from "lucide-react";

import { Button, buttonVariants } from "@/components/ui/button";
import { useTheme } from "@/hooks/use-theme";
import { cn } from "@/lib/utils";

export default function Header() {
  const { theme, toggleTheme } = useTheme();
  // On an org subdomain there is no sign-up (membership is invite-only).
  const isSubdomain = useRouteContext({ from: "__root__", select: (c) => Boolean(c.subdomain) });

  return (
    <header className="border-b bg-background/80 backdrop-blur-sm">
      <div className="flex h-16 items-center justify-between px-6">
        <div className="flex items-center gap-8">
          <Link to="/" className="flex items-center gap-2 text-xl font-bold tracking-tight">
            <img
              src="/afinio-logo.svg"
              alt="Afinio"
              width={20}
              height={20}
              className="h-5 w-5 shrink-0"
            />
            Afinio
          </Link>
          <SignedIn>
            <nav className="flex gap-4">
              <Link
                to="/app"
                className="text-muted-foreground hover:text-foreground text-sm font-medium transition-colors duration-200"
              >
                App
              </Link>
            </nav>
          </SignedIn>
        </div>
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleTheme}
            aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
          >
            {theme === "dark" ? (
              <Sun className="h-5 w-5" aria-hidden="true" />
            ) : (
              <Moon className="h-5 w-5" aria-hidden="true" />
            )}
          </Button>
          <SignedOut>
            <Link to="/sign-in" className={cn(buttonVariants({ variant: "ghost", size: "sm" }))}>
              Sign In
            </Link>
            {!isSubdomain ? (
              <Link to="/create" className={cn(buttonVariants({ size: "sm" }))}>
                Sign Up
              </Link>
            ) : null}
          </SignedOut>
          <SignedIn>
            <UserButton afterSignOutUrl="/" />
          </SignedIn>
        </div>
      </div>
    </header>
  );
}
